import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import StateBlock from '../components/StateBlock';
import EntityLink from '../components/EntityLink';

const DRAWER_TYPES = new Set(['contractor', 'vendor', 'client', 'work_order', 'purchase_order', 'ar_invoice', 'ap_invoice']);

export default function SearchResultsPage() {
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [results, setResults] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (q.trim().length < 2) { setResults({ groups: [] }); return; }
    setResults(null);
    api.get('/search', { params: { q } }).then(r => setResults(r.data));
  }, [q]);

  const totalResults = results?.groups?.reduce((sum, g) => sum + g.results.length, 0) || 0;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Search results for "{q}"</h1>
          {results && <p className="page-subtitle">{totalResults} result{totalResults !== 1 ? 's' : ''} found</p>}
        </div>
      </div>

      {results === null && <StateBlock type="loading" />}

      {results && totalResults === 0 && (
        <StateBlock type="noResults" message={`No matches for "${q}" across contractors, vendors, clients, work orders, or purchase orders.`} />
      )}

      {results && results.groups.map(group => (
        <div key={group.type} style={{ marginBottom: 24 }}>
          <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 10 }}>{group.label}</h3>
          <table className="data-table">
            <tbody>
              {group.results.map(r => (
                <tr key={r.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`${group.route}?highlight=${r.id}`)}>
                  <td>
                    {/* Name opens the entity's side panel; the rest of the row
                        still jumps to its list page. Hexaware batches have no
                        panel, so they keep the plain row link. */}
                    {DRAWER_TYPES.has(group.type)
                      ? <EntityLink type={group.type} id={r.id}>{r.label}</EntityLink>
                      : <button className="row-name-link">{r.label}</button>}
                    {r.sublabel && <div style={{ fontSize: 12, color: 'var(--muted)' }}>{r.sublabel}</div>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
